import React, { Fragment } from 'react';

import HowWorksLeft from './HowWorksLeft';
import HowWorksRight from './HowWorksRight';

const HowWorks = props => (
  <Fragment>
    {window.innerWidth >= 768 ? (
      <div className="landing__section">
        <div className="container section-1__how-works">
          <HowWorksLeft {...props} />
          <HowWorksRight {...props} />
        </div>
      </div>
    ) : (
      <div className="container section-1__how-works">
        <div className="section fp-auto-height">
          <HowWorksLeft {...props} />
        </div>
        <div className="section fp-auto-height">
          <HowWorksRight {...props} />
        </div>
      </div>
    )}
  </Fragment>
);

export default HowWorks;



// WEBPACK FOOTER //
// ./src/components/Static/LandingPageNYC/HowWorks.js